module.exports = __webpack_public_path__ + "static/media/Seam_4342.1c045551.jpg";